import type { PermissionName } from '@/model/permissions'
import type { User } from '@/model/user'
import { userRepository } from '@/repositories/user-repository'
import * as Sentry from '@sentry/vue'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUserStore = defineStore('user', () => {
  const user = ref<User>()
  const userPermissions = ref<PermissionName[]>([])

  const init = async () => {
    if (user.value) {
      return
    }
    const data = await userRepository.getMyUser()
    user.value = data.user
    userPermissions.value = data.userPermissions
    Sentry.setUser({
      id: data.user.id,
      email: data.user.email,
      username: data.user.displayName,
    })
  }
  const resetUser = () => {
    user.value = undefined
    userPermissions.value = []
  }

  const hasPermission = (permission?: PermissionName) =>
    permission == null || userPermissions.value.includes(permission) || userPermissions.value.includes('admin')

  return { user, userPermissions, init, resetUser, hasPermission }
})
